import React, { useState } from "react";
import { toast } from "react-toastify";
import { accountApi, accountErr } from "../../api/account/accountApi";

const PasswordSection: React.FC = () => {
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (form.next.length < 8) {
      toast.error("New password must be at least 8 characters");
      return;
    }
    if (form.next !== form.confirm) {
      toast.error("Passwords do not match");
      return;
    }
    if (form.next === form.current) {
      toast.error("New password must differ from the current one");
      return;
    }
    setBusy(true);
    try {
      await accountApi.changePassword(form.current, form.next);
      toast.success("Password changed");
      setForm({ current: "", next: "", confirm: "" });
    } catch (err) {
      toast.error(accountErr(err, "Could not change password"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="acct-card" onSubmit={submit}>
      <div className="acct-card__head">
        <div>
          <h3>Password</h3>
          <p>Your organisation's password rules (length, symbols) still apply.</p>
        </div>
      </div>
      <div className="acct-form">
        <label className="full">
          Current password
          <input
            type="password"
            autoComplete="current-password"
            value={form.current}
            onChange={(e) => setForm({ ...form, current: e.target.value })}
            required
          />
        </label>
        <label>
          New password
          <input
            type="password"
            autoComplete="new-password"
            value={form.next}
            onChange={(e) => setForm({ ...form, next: e.target.value })}
            minLength={8}
            required
          />
        </label>
        <label>
          Confirm new password
          <input
            type="password"
            autoComplete="new-password"
            value={form.confirm}
            onChange={(e) => setForm({ ...form, confirm: e.target.value })}
            minLength={8}
            required
          />
        </label>
      </div>
      <div className="acct-actions">
        <button
          type="submit"
          className="acct-btn acct-btn--primary"
          disabled={busy || !form.current || !form.next || !form.confirm}
        >
          {busy ? "Changing..." : "Change password"}
        </button>
      </div>
    </form>
  );
};

export default PasswordSection;
